import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "file-link" };
const _hoisted_2 = ["href", "title"];
const _hoisted_3 = {
    key: 1,
    class: "file-link__details"
};
const _hoisted_4 = { class: "file-link__data" };
const _hoisted_5 = { class: "file-link__property" };
const _hoisted_6 = { class: "file-link__value" };
const _hoisted_7 = { class: "file-link__property" };
const _hoisted_8 = { class: "file-link__value" };
const _hoisted_9 = { class: "file-link__property" };
const _hoisted_10 = { class: "file-link__value" };
const _hoisted_11 = {
    key: 0,
    class: "file-link__preview"
};
const _hoisted_12 = ["src"];
import { ref, computed, watch } from 'vue';
import FileIcon from "./FileIcon.vue";
import { palomaUriFilter, isPalomaFilesUri, bytesFilter } from "../util/CommonUiFilters";
import palomaFiles from "../services/PalomaFiles";
import Icon from "./Icon.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FileLink',
    props: {
        uri: {},
        label: {},
        type: {},
        hideInfo: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const objectInfo = ref(null);
        watch(() => props.uri, () => objectInfo.value = null);
        const isPalomaFile = computed(() => {
            return isPalomaFilesUri(props.uri);
        });
        const label_ = computed(() => {
            if (props.label) {
                return props.label;
            }
            if (props.uri.indexOf('files:') === 0) {
                const objectName = props.uri.substring('files:'.length);
                return objectName.substring(objectName.lastIndexOf('/') + 1);
            }
            return props.uri;
        });
        function toggleInfos() {
            if (objectInfo.value) {
                objectInfo.value = null;
                return;
            }
            if (!isPalomaFilesUri(props.uri)) {
                return;
            }
            palomaFiles
                .get(props.uri)
                .then(data => {
                objectInfo.value = data;
            })
                .catch(() => {
                objectInfo.value = null;
            });
        }
        function isSmallishImage() {
            return objectInfo.value
                && objectInfo.value.contentType.indexOf('image/') === 0
                && objectInfo.value.contentLength < 200 * 1024;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", _hoisted_1, [
                _createElementVNode("a", {
                    href: _unref(palomaUriFilter)(__props.uri),
                    target: "_blank",
                    title: __props.type,
                    class: "file-link__link"
                }, [
                    _createVNode(FileIcon, {
                        type: __props.type || 'unknown'
                    }, null, 8, ["type"]),
                    _createTextVNode(" " + _toDisplayString(label_.value), 1)
                ], 8, _hoisted_2),
                _cache[10] || (_cache[10] = _createTextVNode()),
                (isPalomaFile.value && !__props.hideInfo)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (toggleInfos()), ["prevent"])),
                        class: "file-link__info",
                        href: ""
                    }, [
                        _createVNode(Icon, { name: "info" })
                    ]))
                    : _createCommentVNode("", true),
                _cache[11] || (_cache[11] = _createTextVNode()),
                (objectInfo.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                        _createElementVNode("span", _hoisted_4, [
                            _createElementVNode("span", _hoisted_5, [
                                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "file-link__label" }, "Name", -1)),
                                _cache[2] || (_cache[2] = _createTextVNode()),
                                _createElementVNode("span", _hoisted_6, _toDisplayString(objectInfo.value.filename), 1)
                            ]),
                            _cache[7] || (_cache[7] = _createTextVNode()),
                            _createElementVNode("span", _hoisted_7, [
                                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "file-link__label" }, "Type", -1)),
                                _cache[4] || (_cache[4] = _createTextVNode()),
                                _createElementVNode("span", _hoisted_8, _toDisplayString(objectInfo.value.contentType), 1)
                            ]),
                            _cache[8] || (_cache[8] = _createTextVNode()),
                            _createElementVNode("span", _hoisted_9, [
                                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "file-link__label" }, "Size", -1)),
                                _cache[6] || (_cache[6] = _createTextVNode()),
                                _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(bytesFilter)(objectInfo.value.contentLength)), 1)
                            ])
                        ]),
                        _cache[9] || (_cache[9] = _createTextVNode()),
                        (isSmallishImage())
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                _createElementVNode("img", {
                                    src: objectInfo.value.uri
                                }, null, 8, _hoisted_12)
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
